import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField, Button } from '@mui/material';

const TenantSelector = ({
  tenantOptions,
  selectedTenant,
  setSelectedTenant,
  setTenantId,
  setDBType,
}) => {
  const [options, setOptions] = useState([]);
  const [localSelection, setLocalSelection] = useState(null);

  // Flatten tenantOptions into [{ label, value: { key, value } }, ...]
  useEffect(() => {
    const flattened = [];
    for (const key in tenantOptions) {
      const values = tenantOptions[key];
      if (Array.isArray(values)) {
        values.forEach((value) => {
          flattened.push({
            label: `${value}: ${key}`,
            value: { key, value },
          });
        });
      }
    }
    setOptions(flattened);
  }, [tenantOptions]);

  const handleChange = (_, newValue) => {
    if (newValue) {
      setLocalSelection(newValue); // Store locally, not applied yet
    }
  };

  const handleSubmit = () => {
    if (localSelection) {
      setSelectedTenant?.(localSelection);
      setTenantId?.(localSelection.value.value);
      setDBType?.(localSelection.value.key);
    }
  };

  return (
    <>
      <Autocomplete
        options={options}
        value={localSelection}
        onChange={handleChange}
        renderInput={(params) => (
          <TextField {...params} label="Select tenant" />
        )}
        getOptionLabel={(option) =>
          typeof option === 'string'
            ? option
            : option?.label ?? ''
        }
        isOptionEqualToValue={(option, value) =>
          option?.label === value?.label
        }
        disableClearable
        sx={{ mb: 2 }}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        disabled={!localSelection}
      >
        Submit
      </Button>
    </>
  );
};

export default TenantSelector;